import { TOAST_DURATION } from '@/shared/constants';
import type { ToastProps } from './toasts.types';

export const showWarningToast: ToastProps = (toast, options) =>
	toast({
		status: 'warning',
		colorScheme: 'warning',
		title: 'Ошибка',
		isClosable: true,
		variant: 'left-accent',
		duration: TOAST_DURATION,
		position: 'top-left',
		...options,
	});
